module.exports = __webpack_public_path__ + "static/media/autodesk_atlas_thumb.28c0d369.png";